// rendezvousState — the pure AND-join transition for the Rendezvous node.
//
// A rendezvous fires its output only once BOTH inputs (A and B) have arrived.
// State is two booleans; a repeated arrival on the same input is idempotent
// (A, A, B still fires once). On success it AUTO-RESETS to { a:false, b:false }
// so the node re-arms for the next cycle. A `reset` input clears a
// half-completed join without firing.
//
// Kept pure + unit-tested (tests/unit/rendezvousState.test.mjs) so the runtime
// block in EventRuntime stays a thin adapter around it. No imports.

/**
 * @param {{a?:boolean,b?:boolean}|null|undefined} state  prior arrival flags
 * @param {'A'|'B'|'reset'} input  which input just fired
 * @returns {{a:boolean, b:boolean, fire:boolean}}  next flags + whether to fire execOut
 */
export function applyRendezvous(state, input) {
  const a = !!state?.a
  const b = !!state?.b
  if (input === 'reset') return { a: false, b: false, fire: false }
  const na = input === 'A' ? true : a
  const nb = input === 'B' ? true : b
  if (na && nb) return { a: false, b: false, fire: true }  // both arrived → fire + auto-reset
  return { a: na, b: nb, fire: false }                     // still waiting on the other side
}
